
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ImportacaoRegistrosExcelModal from '@/views/Cadastros/Produtos/ImportacaoRegistrosExcelModal.vue';
import storeSistema from '@/store/storeSistema';
import ServicoEtapaProducao from '@/servicos/Cadastros/PCP/ServicoEtapaProducao';
import EtapaProducaoModal from './EtapaProducaoModal.vue';

export default defineComponent({
  name: 'EtapaProducao',
  components: {
    TelaPadraoCrud,
    EtapaProducaoModal,
    ImportacaoRegistrosExcelModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoEtapaProducao = new ServicoEtapaProducao();
    const refCrudEtapaProducao = ref<InstanceType<typeof TelaPadraoCrud>>();
    servicoEtapaProducao.requisicaoSistema();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da etapa de produção:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'Identificador', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 1, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 400, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 2, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'Ações', key: 'acoes', position: 3, visible: true, fixed: 'right', width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'IdentificadorProduto', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      exibirImportacaoExcel: false,
    });

    function abrirImportacaoRegistros() {
      state.exibirImportacaoExcel = false;
    }

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudEtapaProducao.value !== undefined) {
        await refCrudEtapaProducao.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      state,
      storeSistema,
      crudBase,
      servicoEtapaProducao,
      refCrudEtapaProducao,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      abrirImportacaoRegistros,
    };
  },
});
